import React from 'react';
import Banner from '../Banner/Banner';
import Features from '../Features/Features';
import Services from '../Services/Services';
const Home = () => {
  return (
    <div>
      <Banner />
      <Features />
      <Services />
    </div>
  );
};

export default Home;
